export enum FaqScopeTypes {
  WebApp = 1,
  AdminApp = 2
}
